import styled from 'styled-components'

import { type ModularContentBlocks, renderModularBlocks } from '../renderModularBlocks'

const StyledPage = styled.div`
  padding-top: var(--grid-72);
  @media screen and (max-width: ${(p) => p.theme.breakpoints.mobile}) {
    padding-top: 64px;
  }
`

type GutHealthTestPDPContentProps = {
  content: ModularContentBlocks[]
}

export const GutHealthTestPDPContent = ({ content }: GutHealthTestPDPContentProps) => {
  return <StyledPage>{(content ?? []).map((record, index) => renderModularBlocks(record, index))}</StyledPage>
}
